<template>
    <div class="article-cookies-video">
        <p>
            Video cookies enable videos embedded in the website to play, and may involve third party cookies which may
            track information about you.
        </p>
        <ul>
            <li>
                <strong>TikTok Cookies</strong>
                - TikTok use multiple cookies to collect or receive information about you when you play an embedded
                TikTok video on our website. TikTok is a service and their privacy policy is available at:
                <a href="https://www.tiktok.com/legal/privacy-policy">https://www.tiktok.com/legal/privacy-policy</a>
                (cookies used for this purpose are: Multiple TikTok Cookies).
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ArticleCookiesVideo',
};
</script>
